import qs from 'qs';
import { useQuery, useQueries } from 'react-query';

import { axios } from 'lib';

const getFrameworkAgreementsSupplierFilesCount = (faId, facId) => {
  return axios.get(
    `/api/framework_agreements/${faId}/suppliers/${facId}/files/count`
  );
};

export const useFrameworkAgreementsSupplierFilesCount = (faId, facId, options = {}) => {
  return useQuery(
    `framework-agreement-supplier-${facId}-count`,
    () => getFrameworkAgreementsSupplierFilesCount(faId, facId),
    {
      //@ts-ignore
      initialData: { data: { count: 0 } },
      select: ({ data }) => data,
      ...options,
    }
  );
}

export const useFrameworkAgreementsSupplierFilesCountQueries = (faId, facIds, options = {}) => {
  // Use useQueries to create a query for each facId
  const queries = useQueries(
    facIds.map(facId => ({
      queryKey: [`framework-agreement-supplier-${facId}-files-count`, facId],
      queryFn: () => getFrameworkAgreementsSupplierFilesCount(faId, facId),
      initialData: { data: { count: 0 } },
      select: ({ data }) => data,
      ...options,
    }))
  );

  return queries;
};